import { useContext } from 'react'

//contexts
import AuthContext from 'context/AuthContext'

const ContactSupport = () => {
  const { intercomOpen } = useContext(AuthContext)

  return (
    <span
      onClick={() => intercomOpen('home')}
      style={{ color: '#f7a928', textDecoration: 'underline', cursor: 'pointer' }}
    >
      contact our support team
    </span>
  )
}

export default ContactSupport
